import { render, staticRenderFns } from "./PreloaderBackdrop.vue?vue&type=template&id=1ba7a162&"
import script from "./PreloaderBackdrop.vue?vue&type=script&lang=js&"
export * from "./PreloaderBackdrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports